import { render } from "./HeroiconsOutlineUserAdd.vue?vue&type=template&id=d733543c"
const script = {}

import exportComponent from "/www/brandsecurity_2/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineUserAdd.vue"]])

export default __exports__